import React from "react";
import { Modal, Button, Alert } from "antd";

const SuspendUserModal = ({ open, user, block, onCancel, onConfirm }) => {
  const title = block ? "Suspend User" : "Unsuspend User";
  const actionLabel = block ? "Suspend" : "Unsuspend";
  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="confirm" type={block ? "primary" : "default"} danger={!!block} onClick={onConfirm}>
          {actionLabel}
        </Button>,
      ]}
    >
      {user && (
        <div>
          {block ? (
            <Alert
              type="warning"
              showIcon
              message={`This will suspend ${user.name} and revoke sessions.`}
            />
          ) : (
            <Alert type="info" showIcon message={`This will unsuspend ${user.name}.`} />
          )}
        </div>
      )}
    </Modal>
  );
};

export default SuspendUserModal;


